import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Text,
  View,
  StyleSheet,
  SafeAreaView,
  ImageBackground,
  ScrollView,
  TouchableOpacity,
  Platform,
  Linking,
  Image,
  Modal,
  Alert,
} from "react-native";
import RootStore from "../../Store";
import Colors from "../../Theme/Colors";
import typo from "../../Theme/Typo";
import Button from "../Button";
import * as Clipboard from "expo-clipboard";
import ImageViewer from "react-native-image-zoom-viewer";
import Entypo from "@expo/vector-icons/Entypo";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import Queries from "../../api/queries";
import LoadingModal from "../LoadingModal";
import QueryToken from "../../api/queries/queryToken";
import ModalQLerr from "../../utils/ModalQLerr";
import AlertCustom from "../utils/alert";

const { userInfo } = RootStore.getInstance();
const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const DetailsAppart = ({ route }) => {
  // ! for roles
  const queries = new Queries();
  const queriesToken = new QueryToken();
  const [roles, setRoles] = useState([]);

  const [QLerror, setQLerror] = useState("");

  const { t } = useTranslation();
  const { bookingId = "" } = route.params;
  const [bookingInfo, setbookingInfo] = useState({});
  const [appartInfo, setAppartInfo] = useState({});
  const [isLoading, setLoading] = useState(true);

  const [isViewer, setViewer] = useState({
    isVisible: false,
    index: 0,
  });

  const getPrestaInfos = async () => {
    try {
      const responseGraphql = await queries.getPrestaInfo();

      let errors = responseGraphql?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const prestaData = responseGraphql.data.getPrestaInfo;
        const graphqlRoles = await queriesToken.getPrestaRoles(
          prestaData.email
        );

        let errors = graphqlRoles?.errors;

        if (errors && errors.length > 0) {
          const errorMessage: string = errors[0].message;

          setQLerror(errorMessage);
        } else {
          const getPrestaRoles = graphqlRoles.data.getPrestaRoles;
          setRoles(getPrestaRoles);
        }
      }
    } catch (err) {
      setQLerror(err);
    }
  };

  const getDetails = async () => {
    setLoading(true);
    try {
      const responseGraphql = await queries.getBookingDetails(bookingId, "fr");

      let errors = responseGraphql?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const { booking, appartInfo } = responseGraphql.data.getBookingDetails;
        setbookingInfo(booking);
        setAppartInfo(appartInfo);
      }
    } catch (err) {
      setQLerror(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPrestaInfos();
    getDetails();
  }, []);

  const openMap = () => {
    switch (Platform.OS) {
      case "ios":
        Linking.openURL(
          `maps://?address=${appartInfo?.address.streetNumber},${appartInfo?.address.street},${appartInfo?.address.city},${appartInfo?.address.country}`
        );
        break;
      case "android":
        Linking.openURL(
          `http://maps.google.com/maps?q=${appartInfo?.address.streetNumber},${appartInfo?.address.street},${appartInfo?.address.city},${appartInfo?.address.country}`
        );
        break;
    }
  };

  const copyWifiCode = (text: string) => {
    Clipboard.setStringAsync(text);
    AlertCustom(t("COPIED"), t("TEXT_COPIED"));
  };

  const helpCustomerInfo = () => {
    AlertCustom(t("DETAIL_BOOKING_PRICE_TITLE"), t("HELP_CUSTOMER_INFOS"));
  };
  const helpTravelerInfo = () => {
    AlertCustom(t("DETAIL_TRAVELER_TITLE"), t("HELP_TRAVELER_INFOS"));
  };
  const helpAppartInfo = () => {
    AlertCustom(t("DETAIL_APPART_TITLE"), t("HELP_APPART_INFOS"));
  };

  return (
    <SafeAreaView style={typo.mainBackground}>
      <ImageBackground source={BG_PATH} style={typo.background}>
        <ScrollView>
          {QLerror && QLerror !== "" ? (
            <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
          ) : null}
          {isLoading ? (
            <LoadingModal loading={isLoading || isLoading} />
          ) : (
            <View>
              <View style={typo.container}>
                <Text style={typo.titleInfo}>{t("DETAIL_TITLE")}</Text>
                <View style={typo.resCard}>
                  <View style={typo.underlineCat}>
                    <Entypo
                      name="info-with-circle"
                      size={24}
                      color={Colors.oiqia}
                      style={{ marginRight: 10 }}
                      onPress={() => helpTravelerInfo()}
                    />
                    <Text style={typo.category}>
                      {t("DETAIL_TRAVELER_TITLE")}
                    </Text>
                  </View>
                  <View>
                    <Text style={typo.h3}>
                      <Entypo name="user" size={24} color={Colors.oiqia} />
                      <Text style={[typo.body, style.userInfoFirstName]}>
                        {" " + bookingInfo.firstName}
                      </Text>
                      <Text style={[typo.body, style.userInfoLastName]}>
                        {" " + bookingInfo.lastName}
                      </Text>
                    </Text>
                  </View>

                  <View style={style.columnNew}>
                    <Text style={typo.body}>
                      <Entypo
                        name="users"
                        size={24}
                        color={Colors.oiqia}
                      />
                      {" Adultes : "}
                      <Text
                        style={{ color: Colors.oiqia, fontWeight: "700" }}
                      >
                        {bookingInfo.adults || "N/A"}
                      </Text>
                    </Text>
                  </View>

                  <View style={style.columnNew}>
                    <Text style={typo.body}>
                      <FontAwesome
                        name="child"
                        size={24}
                        color={Colors.oiqia}
                      />
                      {" Enfants : "}
                      <Text
                        style={{ color: Colors.oiqia, fontWeight: "700" }}
                      >
                        {bookingInfo.children || "N/A"}
                      </Text>
                    </Text>
                  </View>

                  <View style={style.columnNew}>
                    <View style={style.left}>
                      <Entypo name="calendar" size={24} color={Colors.oiqia} />
                    </View>
                    <View style={style.right}>
                      <Text style={style.newDate}>
                        {bookingInfo.startDate && bookingInfo.endDate && (
                          <Text>
                            {bookingInfo?.startDate +
                              " " +
                              bookingInfo?.startHour}{" "}
                            →{" "}
                            {bookingInfo?.endDate + " " + bookingInfo?.endHour}
                          </Text>
                        )}
                      </Text>
                    </View>
                  </View>
                </View>
                {roles.isCustomer && (
                  <View style={typo.resCard}>
                    <View style={typo.underlineCat}>
                      <Entypo
                        name="info-with-circle"
                        size={24}
                        color={Colors.oiqia}
                        style={{ marginRight: 10 }}
                        onPress={() => helpCustomerInfo()}
                      />
                      <Text style={typo.category}>
                        {t("DETAIL_BOOKING_PRICE_TITLE")}
                      </Text>
                    </View>
                    <View style={{ gap: 10 }}>
                      <Text style={typo.body}>
                        <Entypo
                          name="suitcase"
                          size={24}
                          color={Colors.oiqia}
                        />
                        {" Origine de la réservation : "}
                        <Text
                          style={{ color: Colors.oiqia, fontWeight: "700" }}
                        >
                          {bookingInfo.origin || "N/A"}
                        </Text>
                      </Text>
                      <Text style={typo.body}>
                        <Entypo
                          name="price-tag"
                          size={24}
                          color={Colors.oiqia}
                        />
                        {" Prix de la réservation : "}
                        <Text
                          style={{ color: Colors.oiqia, fontWeight: "700" }}
                        >
                          {bookingInfo.totalPrice} €
                        </Text>
                      </Text>
                    </View>
                    {bookingInfo.intervention != 0 && (
                      <View style={style.dateInfo}>
                        <View style={style.underline}>
                          <Text style={typo.h3}>
                            {t("DETAIL_PRICE_INTERVENTION")} :
                          </Text>
                        </View>
                        <Text style={typo.body}>
                          {bookingInfo.intervention} €
                        </Text>
                      </View>
                    )}
                  </View>
                )}
                <View style={typo.resCard}>
                  <View style={typo.underlineCat}>
                    <Entypo
                      name="info-with-circle"
                      size={24}
                      color={Colors.oiqia}
                      style={{ marginRight: 10 }}
                      onPress={() => helpAppartInfo()}
                    />
                    <Text style={typo.category}>
                      {t("DETAIL_APPART_TITLE")}
                    </Text>
                  </View>
                  <View>
                    <Text style={typo.body}>
                      <Entypo name="address" size={24} color={Colors.oiqia} />
                      {" " + appartInfo?.address?.streetNumber}{" "}
                      {appartInfo?.address?.street}
                    </Text>
                  </View>
                  <View style={style.userInfoNewLine}>
                    <Text style={typo.body}>
                      <Entypo
                        name="location-pin"
                        size={24}
                        color={Colors.oiqia}
                      />
                      {` ${appartInfo?.address?.zipCode} ${appartInfo?.address?.city}, `}
                      {`${appartInfo?.address?.country}`}
                    </Text>
                  </View>
                  {appartInfo?.caracts?.wifiCode.length > 0 &&
                    appartInfo?.caracts?.wifiName.length > 0 && (
                      <View>
                        <View style={style.userInfoNewLine}>
                          <Text style={typo.body}>
                            <Entypo name="rss" size={24} color={Colors.oiqia} />
                            {" " + appartInfo.caracts.wifiName}
                          </Text>
                        </View>
                        <View
                          style={[style.userInfoNewLine, { marginBottom: 5 }]}
                        >
                          <TouchableOpacity
                            onPress={() =>
                              copyWifiCode(appartInfo?.caracts?.wifiCode)
                            }
                          >
                            <Text style={typo.body}>
                              <Entypo
                                name="lock"
                                size={24}
                                color={Colors.oiqia}
                              />
                              {" " + appartInfo?.caracts?.wifiCode}
                            </Text>
                          </TouchableOpacity>
                        </View>
                      </View>
                    )}

                  {/* <View style={style.underline}>
                                        <Text style={typo.h2}>{t("DETAIL_APPART_ADDRESS")} :</Text>
                                    </View>
                                    <View style={style.wrap10}>
                                        <Text style={typo.body}>{appartInfo?.address?.streetNumber}, {appartInfo?.address?.street}</Text>
                                        <Text style={typo.body}>{`${appartInfo?.address?.zipCode} ${appartInfo?.address?.city}`}</Text>
                                        <Text style={typo.body}>{`${appartInfo?.address?.country}`}</Text>
                                    </View> */}
                  <View style={style.userInfoNewLine}>
                    <Button
                      style={{
                        alignSelf: "center",
                        backgroundColor: Colors.oiqia,
                      }}
                      text={t("DETAIL_APPART_MAP")}
                      onPress={openMap}
                    />
                  </View>
                </View>
                {appartInfo?.pictures?.length > 0 && (
                  <View style={typo.resCard}>
                    <View style={typo.underlineCat}>
                      <FontAwesome
                        name="picture-o"
                        size={24}
                        color={Colors.oiqia}
                        style={{ marginRight: 10 }}
                      />
                      <Text style={typo.category}>{"Photos"}</Text>
                    </View>
                    <ScrollView horizontal>
                      {appartInfo?.pictures?.map((element, index) => (
                        <View key={index} style={{ margin: 5 }}>
                          <TouchableOpacity
                            onPress={() =>
                              setViewer({ isVisible: true, index })
                            }
                          >
                            <Image
                              style={style.image}
                              source={{ uri: element.url }}
                            />
                          </TouchableOpacity>
                          <Text
                            style={[
                              typo.body,
                              { alignSelf: "center", width: 200 },
                            ]}
                          >
                            {element.name}
                          </Text>
                        </View>
                      ))}
                    </ScrollView>
                  </View>
                )}
              </View>
              {Platform.OS != "web" && appartInfo.pictures?.length > 0 && (
                <SafeAreaView style={{ flex: 1 }}>
                  <Modal visible={isViewer.isVisible} transparent={true}>
                    <ImageViewer
                      enableSwipeDown={true}
                      index={isViewer.index}
                      imageUrls={appartInfo.pictures?.map((ele) => {
                        return {
                          url: ele.url,
                          props: { source: ele.url },
                        };
                      })}
                      renderHeader={() => (
                        <SafeAreaView>
                          <TouchableOpacity
                            onPress={() =>
                              setViewer({ isVisible: false, index: 0 })
                            }
                          >
                            <Entypo
                              name="cross"
                              onPress={() =>
                                setViewer({ isVisible: false, index: 0 })
                              }
                              size={60}
                              color="white"
                            />
                          </TouchableOpacity>
                        </SafeAreaView>
                      )}
                    ></ImageViewer>
                  </Modal>
                </SafeAreaView>
              )}
            </View>
          )}
        </ScrollView>
      </ImageBackground>
    </SafeAreaView>
  );
};

const style = StyleSheet.create({
  userInfoNewLine: {
    marginTop: 8,
  },
  userInfoPhone: {
    textTransform: "lowercase",
    fontSize: 16,
  },

  userInfoFirstName: {
    textTransform: "capitalize",
  },

  userInfoLastName: {
    textTransform: "uppercase",
  },
  Button: {
    backgroundColor: Colors.oiqia,
    borderRadius: 10,
    justifyContent: "center",
    color: "white",
    height: 44,
    width: "130%",
  },
  newDate: {
    fontWeight: "bold",
    color: Colors.oiqia,
    textAlignVertical: "center",
  },
  columnNew: {
    flex: 1,
    alignSelf: "flex-start",
    flexDirection: "row",
    marginTop: 10,
  },
  left: {
    alignSelf: "flex-start",
  },
  right: {
    marginLeft: 5,
    alignSelf: "flex-end",
  },
  Buttonbox: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
  text: {
    width: "90%",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  box: {
    backgroundColor: "#ffffffe6",
    borderRadius: 10,
    margin: 2,
    padding: 6,
  },
  containerDrop: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: 30,
    marginRight: 30,
    marginTop: 10,
  },
  spaceBet: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  marginTop: {
    marginTop: 10,
  },
  column: {
    flex: 1,
    alignSelf: "auto",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  dateInfo: {
    width: "50%",
    padding: 5,
    textAlign: "left",

    justifyContent: "flex-start",
  },
  underline: {
    borderColor: "#0A0A0AE7",
    borderBottomWidth: 0.5,
    paddingBottom: 5,
    marginBottom: 10,
  },
  underlineDot: {
    borderColor: "#0A0A0AE7",
    borderStyle: "dashed",
    borderRadius: 1,
    borderBottomWidth: 1,
    paddingBottom: 10,
    marginBottom: 10,
  },
  wrap10: {
    margin: 15,
  },
  image: {
    //padding: 5,
    left: 5,
    top: 5,
    width: 200,
    height: 150,
    borderWidth: 1,
    borderRadius: 1,
    marginRight: 10,
    borderColor: "white",
    marginBottom: 5,
  },
});

export default observer(DetailsAppart);
